import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function PaiementPaypalBlackIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<g opacity="0.68">
				<g opacity="0.68">
					<g opacity="0.68">
						<path
							opacity="0.68"
							d="M19.288 7.08199C19.5329 5.52708 19.288 4.46784 18.4439 3.50842C17.5139 2.45445 15.8399 2 13.701 2H7.48011C7.26804 1.99992 7.06292 2.07567 6.90181 2.21359C6.7407 2.3515 6.63422 2.54248 6.6016 2.75204L4.00574 19.1682C3.99547 19.2377 3.99901 19.3084 4.01615 19.3765C4.0333 19.4445 4.06371 19.5085 4.10564 19.5648C4.14757 19.6211 4.2002 19.6685 4.26051 19.7044C4.32082 19.7403 4.38762 19.7639 4.45708 19.7739C4.4825 19.7781 4.5082 19.7803 4.53396 19.7805H8.37785L8.11311 21.4594C8.10339 21.52 8.10573 21.5819 8.11998 21.6417C8.13423 21.7014 8.16013 21.7577 8.19618 21.8074C8.23223 21.8571 8.27773 21.8992 8.33007 21.9313C8.38242 21.9634 8.44058 21.9848 8.50122 21.9944C8.52531 21.9983 8.54968 22.0001 8.57407 22H11.8101C11.9931 22.0004 12.1704 21.9363 12.3109 21.8189C12.4514 21.7016 12.546 21.5385 12.5782 21.3583L12.6111 21.1949L13.2224 17.3229L13.2608 17.1083C13.29 16.9256 13.3834 16.7593 13.5242 16.6392C13.665 16.5191 13.8439 16.4531 14.029 16.453H14.5138C17.6475 16.453 20.1033 15.179 20.8305 11.495C21.1219 9.94662 20.9625 8.66883 20.1702 7.76459C19.919 7.4865 19.6201 7.25554 19.2877 7.08261"
							fill="currentColor"
						/>
					</g>
				</g>
			</g>
			<g opacity="0.7">
				<g opacity="0.7">
					<g opacity="0.7">
						<path
							opacity="0.7"
							d="M19.288 7.08199C19.5329 5.52708 19.288 4.46784 18.4439 3.50842C17.5139 2.45445 15.8399 2 13.701 2H7.48011C7.26804 1.99992 7.06292 2.07567 6.90181 2.21359C6.7407 2.3515 6.63422 2.54248 6.6016 2.75204L4.00574 19.1682C3.99547 19.2377 3.99901 19.3084 4.01615 19.3765C4.0333 19.4445 4.06371 19.5085 4.10564 19.5648C4.14757 19.6211 4.2002 19.6685 4.26051 19.7044C4.32082 19.7403 4.38762 19.7639 4.45708 19.774C4.4825 19.7781 4.5082 19.7803 4.53396 19.7805H8.37785L9.3413 13.6671L9.3103 13.8593C9.34292 13.6502 9.44911 13.4595 9.60975 13.3217C9.7704 13.1838 9.97496 13.1078 10.1866 13.1073H12.0199C15.604 13.1073 18.4104 11.6525 19.2297 7.44344C19.2536 7.31944 19.2737 7.19855 19.2917 7.07858"
							fill="currentColor"
						/>
					</g>
				</g>
			</g>
			<path
				d="M10.3777 7.10369C10.3981 6.97893 10.4482 6.86088 10.5237 6.75951C10.5992 6.65814 10.698 6.57641 10.8117 6.52122C10.9165 6.47087 11.0315 6.4451 11.1478 6.44589H16.0283C16.5664 6.44214 17.104 6.48143 17.6359 6.56338C17.7766 6.58663 17.9149 6.61297 18.0438 6.64087C18.1728 6.66877 18.3064 6.70287 18.4304 6.741L18.6164 6.79773C18.848 6.87386 19.073 6.96861 19.2894 7.08106C19.5343 5.52615 19.2894 4.46691 18.4459 3.50749C17.5131 2.45197 15.8423 2 13.6993 2H7.48026C7.26833 1.99985 7.06333 2.07552 6.90233 2.21333C6.74132 2.35114 6.63492 2.542 6.60236 2.75142L4.00681 19.1682C3.99646 19.2375 3.99991 19.3082 4.01697 19.3762C4.03404 19.4442 4.06437 19.5081 4.10623 19.5643C4.14809 19.6205 4.20065 19.6679 4.26089 19.7037C4.32113 19.7395 4.38785 19.7631 4.45723 19.773C4.48264 19.7772 4.50835 19.7793 4.5341 19.7795H8.37799L9.34237 13.6668L10.3777 7.10369Z"
				fill="currentColor"
			/>
		</svg>
	);
}

PaiementPaypalBlackIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default PaiementPaypalBlackIcon;
